const baseName = process.env.REACT_APP_BASE_URL;

export const IMAGE_PATHS = {
    time_icon: `${baseName}/images/time_icon.svg`,

}

export const surveyorTypeObj = {
    SELF_SURVEYOR: 'Self Surveyor',
    DEFAULT_SURVEYOR: 'Default Surveyor',
    APPOINT_SURVEYOR: 'Appoint Surveyor'
}
